/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Right_NameInputs */

const en_directory_comparison_product_hunt_right_name = /** @type {(inputs: Directory_Comparison_Product_Hunt_Right_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt`)
};

const zh_directory_comparison_product_hunt_right_name = /** @type {(inputs: Directory_Comparison_Product_Hunt_Right_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Hunt`)
};

/**
* | output |
* | --- |
* | "Product Hunt" |
*
* @param {Directory_Comparison_Product_Hunt_Right_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_right_name = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Right_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Right_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_right_name(inputs)
	return zh_directory_comparison_product_hunt_right_name(inputs)
});
export { directory_comparison_product_hunt_right_name as "directory.comparison.product_hunt.right_name" }